var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSampleScorecard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000130635039545316922960000012992235829639401636_);}\n\t.st2{fill:url(#SVGID_00000128463250586232773760000006720670606862961028_);}\n\t.st3{fill:url(#SVGID_00000155850571227408540860000010223334909528309170_);}\n\t.st4{fill:url(#SVGID_00000138538741201760992140000015066309005550693775_);}\n\t.st5{fill:url(#SVGID_00000026160123595741988200000003750373068707518114_);}\n\t.st6{fill:url(#SVGID_00000092450466516085751140000008458771076138640006_);}\n\t.st7{fill:url(#SVGID_00000107563280867338321330000013358810379255098281_);}\n\t.st8{fill:url(#SVGID_00000119816283664037620920000008950085298830680205_);}\n\t.st9{fill:url(#SVGID_00000051374953921219684850000003204649618354643852_);}\n\t.st10{fill:url(#SVGID_00000020391135044079630660000013190437270250518149_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 291.5211,
    x2: 510.3878,
    y2: 291.5211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.1,284.2H48.6c-3-8.2-10.8-14.1-20.1-14.1c-11.9,0-21.5,9.6-21.5,21.5S16.6,313,28.5,313 c9.3,0,17.1-5.9,20.1-14.1h140.5c4,0,7.3-3.3,7.3-7.3S193.1,284.2,189.1,284.2z M28.5,300.4c-4.9,0-8.9-4-8.9-8.9 c0-4.9,4-8.9,8.9-8.9s8.9,4,8.9,8.9C37.4,296.4,33.4,300.4,28.5,300.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111150708867416676710000006477952969866360229_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 209.8003,
    x2: 510.3878,
    y2: 209.8003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111150708867416676710000006477952969866360229_)"
    },
    d: "M66.2,203c9.3,0,17.1-5.9,20.1-14.1H119 v63.4c0,4,3.3,7.3,7.3,7.3h28.2c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3h-20.9l-0.3-63.5c0-4-3.3-7.3-7.3-7.3 c-0.4,0-0.5-0.1-0.8,0H86.3c-3-8.2-10.8-14.1-20.1-14.1c-11.9,0-21.5,9.6-21.5,21.5S54.3,203,66.2,203z M66.2,172.6 c4.9,0,8.9,4,8.9,8.9c0,4.9-4,8.9-8.9,8.9s-8.9-4-8.9-8.9C57.3,176.6,61.3,172.6,66.2,172.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016768263001239234770000007343474303223179152_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 373.242,
    x2: 510.3878,
    y2: 373.242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016768263001239234770000007343474303223179152_)"
    },
    d: "M154.5,323.5h-28.2c-4,0-7.3,3.3-7.3,7.3 v63.4H86.3c-3-8.2-10.8-14.1-20.1-14.1c-11.9,0-21.5,9.6-21.5,21.5c0,11.9,9.6,21.5,21.5,21.5c9.3,0,17.1-5.9,20.1-14.1h38.9 c0.4,0.1,0.4,0,0.8,0c4,0,7.3-3.3,7.3-7.3l0.3-63.5h20.9c4,0,7.3-3.3,7.3-7.3C161.8,326.7,158.5,323.5,154.5,323.5z M66.2,410.4 c-4.9,0-8.9-4-8.9-8.9c0-4.9,4-8.9,8.9-8.9s8.9,4,8.9,8.9C75.1,406.4,71.1,410.4,66.2,410.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049907120923915834160000001337351468615462843_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 269.943,
    x2: 510.3878,
    y2: 269.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 312.5,
    y: 262.8,
    style: {
      fill: "url(#SVGID_00000049907120923915834160000001337351468615462843_)"
    },
    width: 229,
    height: 14.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132073047456292931440000016475448372688298662_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 269.943,
    x2: 510.3878,
    y2: 269.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 262.8,
    style: {
      fill: "url(#SVGID_00000132073047456292931440000016475448372688298662_)"
    },
    width: 51.9,
    height: 14.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178924027762814479340000002204492516316222605_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 304.3537,
    x2: 510.3878,
    y2: 304.3537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 297.2,
    style: {
      fill: "url(#SVGID_00000178924027762814479340000002204492516316222605_)"
    },
    width: 51.9,
    height: 14.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036972210308034677500000010087082618831142023_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 338.7645,
    x2: 510.3878,
    y2: 338.7645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 331.6,
    style: {
      fill: "url(#SVGID_00000036972210308034677500000010087082618831142023_)"
    },
    width: 51.9,
    height: 14.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049919530141173618550000011170305167245300920_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 304.3537,
    x2: 510.3878,
    y2: 304.3537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 312.5,
    y: 297.2,
    style: {
      fill: "url(#SVGID_00000049919530141173618550000011170305167245300920_)"
    },
    width: 229,
    height: 14.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162319930052058279550000008529207146795497890_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 338.7645,
    x2: 510.3878,
    y2: 338.7645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 312.5,
    y: 331.6,
    style: {
      fill: "url(#SVGID_00000162319930052058279550000008529207146795497890_)"
    },
    width: 229,
    height: 14.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059990591316824813720000017343662091406896772_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 373.1753,
    x2: 510.3878,
    y2: 373.1753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 312.5,
    y: 366,
    style: {
      fill: "url(#SVGID_00000059990591316824813720000017343662091406896772_)"
    },
    width: 229,
    height: 14.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075154931149363792810000012405755158402081979_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1593,
    y1: 291.9973,
    x2: 510.3878,
    y2: 291.9973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075154931149363792810000012405755158402081979_)"
    },
    d: "M216.1,165.6v252.8h367.3V165.6H216.1z  M525,208.3h15.9v14.4H525V208.3z M498.4,208.3h15.9v14.4h-15.9V208.3z M471.8,208.3h15.9v14.4h-15.9V208.3z M445.3,208.3h15.9 v14.4h-15.9V208.3z M418.7,208.3h15.9v14.4h-15.9V208.3z M392.2,208.3h15.9v14.4h-15.9V208.3z M365.6,208.3h15.9v14.4h-15.9V208.3z  M339,208.3h15.9v14.4H339V208.3z M312.5,208.3h15.9v14.4h-15.9V208.3z M232,208.3h67.9v14.4H232V208.3z M567.4,402.4H232V234.3 h335.4V402.4z M567.4,222.7h-15.9v-14.4h15.9V222.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSampleScorecard);
export default __webpack_public_path__ + "static/media/icon-sample-scorecard.f50f160810c64101ed74547095ea1638.svg";
export { ForwardRef as ReactComponent };